export default __webpack_public_path__ + "static/media/pexels-pixabay-34514.a2c07042.jpg";